<template>
  <div class="bookStatistics">
    <div class="title">知识图谱</div>
    <div class="chartView">
      <div class="box-chart" id="knowledgeMap"></div>
    </div>
  </div>
</template>

<script>
import statisticsApi from '@/api/statistics';

export default {
  data () {
    return {
      records: {},
      colors: [
        'rgb(145,204,117)',
        'rgb(250,200,88)',
        'rgb(239,110,110)',
        'rgb(122,195,224)',
        'rgb(115,192,222)',
        'rgb(252,132,82)',
        'rgb(154,96,180)',
        'rgb(84,112,198)',
        'rgb(247,44,91)'
      ],
      countAll: 1
    };
  },
  mounted () {
    this.getData();
  },
  methods: {
    getData () {
      let that = this;
      that.records = {};
      statisticsApi
        .getKnowledgeMap({
          type: 'book',
          libraryCode: this.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
             that.records = response.data;
            that.setChart();
          }
        });
    },
    setChart () {
        let that = this;
        let option;
        let myChart = this.$echarts.init(
        document.getElementById('knowledgeMap')
      );
          that.records.nodes.forEach(function (node) {
            node.symbolSize = 25;
          });
          option = {
            tooltip: {},
            legend: [
              {
                // selectedMode: 'single',
                data: that.records.categories.map(function (a) {
                  return a.name;
                })
              }
            ],
            series: [
              {
                type: 'graph',
                layout: 'force',
                data: that.records.nodes,
                links: that.records.links,
                categories: that.records.categories,
                roam: true,
                 label: {
                    show: true,
                    position: 'center',
                    formatter: function (value) {
                      if (value.name.length > 3) {
                        return value.name.substring(0, 3) + '...';
                      } else {
                        return value.name;
                      }
                    }
                   },
                force: {
                  repulsion: 100
                },
                  lineStyle: {
          color: 'source',
          curveness: 0.3
        }
              }
            ]
          };
          myChart.setOption(option);
        }
    }
};
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.bookStatistics {
  width: 100%;
  height: 1000px;
  position: relative;

  .title {
    font-size: 16 * @uw;
    color: #8d5e1a;
    margin: 0 * @uh 0px 20 * @uh 10 * @uw;
    padding-top: 10 * @uh;
  }

  .chartView {
    width: 100%;
    height: 95%;
    display: flex;

    .box-chart {
      width: 100%;
      height: 100%;
      padding-left: 20 * @uw;

      .line-view {
        display: flex;
        align-items: center;
        margin-bottom: 15 * @uh;

        .line-title {
          width: 100 * @uw;
          display: flex;
          flex-direction: row-reverse;
        }

        .progress {
          width: 50%;
          border-radius: 5 * @uw;
          height: 7 * @uh;
          margin-left: 10 * @uw;
          margin-right: 10 * @uw;
          background: #dfdedd;

          .progress-inner {
            height: 100%;
            border-radius: 5 * @uw;
          }
        }
      }
    }
  }
}
</style>
